
  import React from "react"
  import Component from "/Users/josh/sites/blog/blog/josh/src/layouts/index.js"
  import data from "/Users/josh/sites/blog/blog/josh/.cache/json/layout-index.json"

  export default (props) => <Component {...props} {...data} />
  


// WEBPACK FOOTER //
// ./.cache/layouts/index.js